<mc-switch-board [color]="color">
  <mc-switch-board-bar class="mc-spring-board">
    <ng-container *ngIf="license$ | async as license">
      <div class="mc-spring-board-header">
        <mc-license-avatar [license]="license" [showName]="false" [disabled]="true" size="large"></mc-license-avatar>
      </div>

      <div class="mc-spring-board-body">
        <h3 class="text-x-large mc-license-profile-title mc-break-text">{{ license.KeyLabel || 'License' }}</h3>
        <ul class="mc-property-list">
          <li>
            <span class="mc-property-name">Flare Online Key: </span>
            <span class="mc-property-value">{{ license.ShortKey }} {{ license.LicenseType === LicenseType.Trial ? ' - Trial' : '' }}</span>
          </li>
          <li>
            <span class="mc-property-name">{{ license.LicenseType === LicenseType.Trial ? 'Expiration' : 'Renewal' }} Date: </span>
            <span class="mc-property-value">{{ expirationDate$ | async | date: 'shortDate' }}</span>
          </li>
          <li>
            <span class="mc-property-name">Renewal Type: </span>
            <span class="mc-property-value">
              <ng-container *ngIf="license.AutoRenewMonths >= 12">Annual</ng-container>
              <ng-container *ngIf="license.AutoRenewMonths === 1">Monthly</ng-container>
              <ng-container *ngIf="!license.AutoRenewMonths">None</ng-container>
            </span>
          </li>
          <li>
            <span class="mc-property-name">Auto Renew: </span>
            <span class="mc-property-value">
              {{ license.IsAutoRenew ? 'Yes': 'No' }}
            </span>
          </li>
          <li>
            <span class="mc-property-name">Single Sign-On: </span>
            <span class="mc-property-value">
              {{ (ssoSettings$ | async)?.Enabled ? 'Enabled': 'Disabled' }}
            </span>
          </li>
        </ul>
      </div>

      <mat-nav-list class="mc-spring-board-footer mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-dark mc-list-compact">
        <a href="#" mat-list-item [mcProfileTab]="LicenseProfileTab.Overview" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-overview" color="primary"></mat-icon> Overview
        </a>
        <a *ngIf="showSettingsTab$ | async" href="#" mat-list-item [mcProfileTab]="LicenseProfileTab.Settings" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-pen" color="primary"></mat-icon> Settings
        </a>
        <a *ngIf="showSubscriptionTab$ | async" href="#" mat-list-item [mcProfileTab]="LicenseProfileTab.Subscription" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-credit-card" color="primary"></mat-icon> Subscription
        </a>
        <a href="#" *ngIf="showIntegrationsTab$ | async" mat-list-item [mcProfileTab]="LicenseProfileTab.Integrations" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-plug" color="primary"></mat-icon> Integrations
        </a>
        <a *ngIf="showSecurityTab$ | async" href="#" mat-list-item [mcProfileTab]="LicenseProfileTab.Security" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-privacy" color="primary"></mat-icon> Security
        </a>
        <a *ngIf="showSsoTab$ | async" href="#" mat-list-item [mcProfileTab]="LicenseProfileTab.SSO" [(mcProfileTabSelected)]="profileTab">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-sso" color="primary"></mat-icon> Single Sign-On
        </a>
      </mat-nav-list>
    </ng-container>
  </mc-switch-board-bar>

  <mc-switch-board-content [ngSwitch]="profileTab" class="mc-spring-board">
    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="LicenseProfileTab.Overview">
      <mat-tab label="Overview">
        <mc-license-overview [license]="license$ | async"></mc-license-overview>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="LicenseProfileTab.Settings">
      <mat-tab label="Settings">
        <mc-license-settings-form [license]="license$ | async" (cancel)="onCancel()" (saved)="onSettingsSaved()" #licenseSettingsForm></mc-license-settings-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="LicenseProfileTab.Subscription">
      <mat-tab label="Subscription">
        <mc-license-subscription [license]="license$ | async" [licenseUser]="licenseUser$ | async"></mc-license-subscription>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" [selectedIndex]="licenseProfileTabGroupIndex" *ngSwitchCase="LicenseProfileTab.Integrations">
      <mat-tab label="Connectors">
        <mc-license-connectors [licenseId]="(license$ | async)?.Id" #licenseConnectors></mc-license-connectors>
      </mat-tab>
      <mat-tab label="Slack">
        <mc-license-slack-form [license]="license$ | async" [licenseUser]="licenseUser$ | async" [subscribers]="subscribers$ | async" [channels]="channels$ | async" [auditCategoryTree]="(auditCategoryTree$ | async)" (cancel)="onCancel()" #licenseSlackForm></mc-license-slack-form>
      </mat-tab>
      <mat-tab label="AI Assist">
        <mc-license-open-ai-form [license]="license$ | async" (cancel)="onCancel()" #licenseOpenAiForm></mc-license-open-ai-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="LicenseProfileTab.Security">
      <mat-tab label="Security">
        <mc-license-security-form [license]="license$ | async" [readOnly]="!(userCanManageServer$ | async)" (cancel)="onCancel()" (saved)="onSecuritySaved()" #licenseSecurityForm></mc-license-security-form>
      </mat-tab>
    </mat-tab-group>

    <mat-tab-group mat-stretch-tabs="false" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert" *ngSwitchCase="LicenseProfileTab.SSO">
      <mat-tab label="Single Sign-On">
        <ng-template mat-tab-label>
          Single Sign-On
        </ng-template>
        <mc-license-sso-form [license]="license$ | async" (saved)="onSsoSaved()" #licenseSsoForm></mc-license-sso-form>
      </mat-tab>
    </mat-tab-group>
  </mc-switch-board-content>
</mc-switch-board>